import { Injectable } from '@angular/core';
import { CookieService, CookieOptions } from 'ngx-cookie';
import { EnvironmentService } from '../environment.service';
import { AppService } from '../../state/app';
import { SemTrackingRequest, TrackingService } from '@legalzoom/tracking-sdk';

@Injectable()

export class TrackSEMDataService {
  constructor(
    private environmentService: EnvironmentService,
    private cookieService: CookieService,
    private appService: AppService,
    private tracking: TrackingService) { }

  private kenshooData = this.environmentService.getTestKenshooData();
  private isProd = this.environmentService.isProduction();
  private testKenshoo = this.environmentService.isInKenshooTestMode();

  public track() {
    const kidTemp = this.cookieService.get('sem_kid');
    const tsUrlTemp = this.cookieService.get('sem_tsaurl');
    const body: SemTrackingRequest = {
      sem: '',
      kid: kidTemp,
      tsaUrl: tsUrlTemp,
      createdBy: 'LZWebINC'
    };
    const userOrderId = this.appService.app.processingOrderId.toString();
    return this.tracking.postSemTrackingData(body, this.appService.app.customerId, userOrderId);
  }

  private createSEMCookies(name, value, days) {
    try {
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const cookieDomain = window.location.hostname === 'localhost' ? 'localhost' : 'legalzoom.com';
        const cookieExpires = date.toUTCString();
        const cookieOptions: CookieOptions = { domain: cookieDomain, expires: cookieExpires };
        this.cookieService.put(name, value, cookieOptions);
      }

    } catch (ex) {
      return null;
    }
  }

  private getKid(sURL) {
    try {
      // tslint:disable-next-line: variable-name
      const oRegExp_kid = new RegExp('kid=([^&]*)?', 'mi');
      if (oRegExp_kid.exec(sURL) != null) {
        return oRegExp_kid.exec(sURL)[1];

      } else {
        return '';
      }
    } catch (ex) {
      return null;
    }
  }

  public setSEMCookies() {
    try {
      let sURL = '';
      let sKid = '';
      if (!this.isProd && this.testKenshoo) {
        sURL = this.kenshooData.url;
        sKid = this.kenshooData.id;
      } else {
        sURL = window.location.href;
        sKid = this.getKid(sURL);
      }
      if (sKid !== '') {
        this.createSEMCookies('sem_kid', sKid, 90);
        this.createSEMCookies('sem_tsaurl', sURL, 90);
      }
    } catch (ex) {

    }
  }
}
